import type { AboutContentSource } from '../domain/repositories/AboutContentSource.interface';
import type { AboutContentInput } from '../domain/entities/AboutContent.entity';
import { aboutContent } from '../content/about.content';

export class StaticAboutContentSource implements AboutContentSource {
  public async getAboutContent(): Promise<AboutContentInput> {
    return aboutContent;
  }
}
